import { render, staticRenderFns } from "./EditResourceModal.vue?vue&type=template&id=76700f04&scoped=true&"
import script from "./EditResourceModal.vue?vue&type=script&lang=js&"
export * from "./EditResourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76700f04",
  null
  
)

export default component.exports